import React, { Component } from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import { Preloader } from '../';
import { UsersService } from '../../services/user';
import './sso.css';

export default class SSOV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  componentDidMount() {
    this.handleSSOV2();
  }

  async handleSSOV2() {
    // Limpar todos os dados de autenticação antes do novo SSO
    await this.clearAllAuthData();

    const { connector, valueType, value, state } = this.props.match.params;
    const queryParams = new URLSearchParams(this.props.location.search);
    const path = queryParams.get("path") || "";

    if (!connector || !valueType || !value || !state) {
      this.redirectToLogin();
      return;
    }

    try {
      let data = { connector, state, path };
      data[valueType] = value;

      await this.authenticateSSOFromProvision(data);
    } catch (error) {
      console.error('Erro no SSO V2:', error);
      this.redirectToLogin();
    }
  }

  async clearAllAuthData() {
    console.log('Limpando dados de autenticação...');
    
    try {
      await UsersService.signOut();
      
      // Forçar limpeza completa do SDK
      if (window.Sdk && window.Sdk.Api && window.Sdk.Api.authorization) {
        window.Sdk.Api.authorization.credential = null;
        window.Sdk.Api.authorization.user = null;
        window.Sdk.Api.authorization.activeProject = null;
        delete window.Sdk.Api.authorization.credential;
        delete window.Sdk.Api.authorization.user;
        delete window.Sdk.Api.authorization.activeProject;
      }
      
      // Limpar headers de autorização se existirem
      if (window.Sdk && window.Sdk.Api && window.Sdk.Api.headers) {
        delete window.Sdk.Api.headers.Authorization;
        delete window.Sdk.Api.headers.authorization;
      }
      
      // Disparar evento de logout
      window.dispatchEvent(new Event("@rdpplayer.event(logout)"));
      
    } catch (e) {
      console.log('Erro ao fazer signOut:', e);
    }
    
    console.log('Limpeza concluída');
  }

  async authenticateSSOFromProvision(params) {
    try {
      await Sdk.Api.authorization.signinProvisionSSO(params);
      
      // Redirecionar para o path especificado
      window.location.hash = params.path || '/';
    } catch (error) {
      console.error('Erro na autenticação SSO V2:', error);
      this.redirectToLogin();
    }
  }

  redirectToLogin() {
    window.location.hash = '/login';
  }

  render() {
    return (
      <div className="rdp-react-template-view-sso-v2">
        <Preloader show={this.state.loading} />
      </div>
    );
  }
}
